import { LiteralUnion } from 'antd/lib/_util/type'
import firebase from 'firebase'

export const logAnalyticsEvent = (eventName: LiteralUnion<firebase.analytics.EventNameString, string>, eventParams?: { [key: string]: any }) => {
    const analytics = firebase.analytics()
    analytics.logEvent(eventName as string, eventParams)
}

